import { readConsentStatus } from './ConsentStorage';

const DIDOMI_TOKEN_COOKIE_NAME = 'euconsent-v2';
const DIDOMI_TOKEN_COOKIE_NAME_QA = 'euconsent';

export const configureGdprConsent = () => {
  window.gdprAppliesGlobally = true;
};

export const getGdprConsentCookieName = debug =>
  debug ? DIDOMI_TOKEN_COOKIE_NAME_QA : DIDOMI_TOKEN_COOKIE_NAME;

export const isGdprConsentCookieSet = didomiUtils =>
  window.document.cookie.indexOf(didomiUtils.getDidomiTokenCookieName()) !== -1;

export const getGdprConsentStatus = (didomiUtils, currentStatus) => {
  const cachedStatus = readConsentStatus();
  if (!didomiUtils.isDidomiTokenCookieSet() || !cachedStatus) {
    return currentStatus;
  }
  return cachedStatus;
};

export const createGdprConsentTracker = ({
  hasConsentCookie,
  notifyExistingConsent,
}) => ({
  onReady() {
    if (!hasConsentCookie()) {
      return;
    }
    notifyExistingConsent();
  },
  onNoticeShown() {
    // Displaying the GDPR banner is not a consent change.
  },
  shouldNotifyConsentChange() {
    // Preserve every SDK consent.changed event, including unchanged saves.
    return true;
  },
});
